var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_136_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9328 0.0568848L0.146484 7.49056L3.58931 35.1649L21.9559 44.952L40.4173 35.0323L43.8588 7.35891L21.9328 0.0568848Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6846 8.95829L21.8809 2.41064V42.6137L38.4773 33.7083L41.6846 8.95829Z",
    fill: "#A6120D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58984 9.0762L5.54008 33.8265L21.8802 42.6136V2.40991L2.59002 9.07604L2.58984 9.0762Z",
    fill: "#DD1B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3335 23.8127L21.8821 26.2843H16.1365L13.4357 32.8341L8.41211 32.9241L21.8821 3.87061L27.3335 23.8128V23.8127ZM26.8065 22.5684L21.9184 13.186L17.9087 22.4069H21.882L26.8065 22.5685V22.5684Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8809 3.87036L21.917 13.1859L26.4665 22.414H21.8912L21.8809 26.2782L28.2076 26.284L31.1645 32.925L35.9713 33.0113L21.8809 3.87036Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.8c71bbab33490441ae576147ff235b13.svg";
export { ForwardRef as ReactComponent };